/**
 * CSS class names used throughout the application.
 * These classes are primarily used for conditional styling and toggling behavior.
 */
export const enum ClassName {
    LEGACY_BODY_BACKGROUND_STYLE = "body-background-style",
    EUC_BODY_BACKGROUND_STYLE = "euc-body-background-style",
    DESKTOP_LAPTOP_DEVICE_TYPE = "desktop-laptop",
    MOBILE_TABLET_DEVICE_TYPE = "mobile-tablet",
    CUSTOM_BACKGROUND_IMG = "custom-background-img",
    CUSTOM_LIGHT_FONT_THEME = "custom-light-theme",
    CUSTOM_DARK_FONT_THEME = "custom-dark-theme",
}

export enum WelcomeTextLengthClassName {
    EXTRA_EXTRA_LONG = "xx-long-welcome-text",
    EXTRA_LONG = "x-long-welcome-text",
    LONG = "long-welcome-text",
    MEDIUM = "medium-welcome-text",
    SHORT = "short-welcome-text",
    EXTRA_SHORT = "x-short-welcome-text",
}

export enum WelcomeTextLengthThreshold {
    EXTRA_EXTRA_LONG = 350, // Mostly for CJK characters
    EXTRA_LONG = 120,
    LONG = 90,
    MEDIUM = 60,
    SHORT = 30,
    EXTRA_SHORT = 0,
}
